import { useState, useEffect, useRef } from "react";

export function useDebounceValue(value, delay = 300) {
  const [debouncedValue, setDebouncedValue] = useState(value);
  const previousValueRef = useRef(value);
  const timeoutRef = useRef(null);

  useEffect(() => {
    // Only update if the value has actually changed
    if (value !== previousValueRef.current) {
      // Clear previous timeout
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }

      timeoutRef.current = setTimeout(() => {
        setDebouncedValue(value);
        previousValueRef.current = value;
      }, delay);

      return () => {
        if (timeoutRef.current) {
          clearTimeout(timeoutRef.current);
        }
      };
    }
  }, [value, delay]);

  return debouncedValue;
}
